import React from 'react';
import { Flex, Stack, Skeleton, SkeletonText, HStack } from '@chakra-ui/react';

const CartProductCardSkeleton = () => {
  return (
    <Flex width="100%" gap={5} position="relative" paddingTop="27px" paddingX="22px" paddingBottom="32px">
      <Stack
        alignItems="center"
        justifyContent="center"
        minWidth="112px"
        width="112px"
        height="112px"
        border="1px solid"
        borderColor="neutral.20"
        borderRadius="8px"
        padding={1}
      >
        <Skeleton width="100px" height="100px" borderRadius="4px" />
      </Stack>

      <Flex direction="column" width="100%" justifyContent="space-between">
        <Flex direction="column" justifyContent="space-between" width="100%" marginBottom={3}>
          <Flex direction="row" gap={1} alignItems="center" justifyContent="space-between">
            <SkeletonText noOfLines={1} width="70%" />
            <Skeleton width="24px" height="24px" borderRadius="12px" />
          </Flex>

          <HStack gap={2} marginTop={1}>
            <Skeleton width="60px" height="14px" />
            <Skeleton width="60px" height="14px" />
          </HStack>
        </Flex>

        <Flex justify="space-between" width="100%" align="center">
          <Skeleton width="80px" height="24px" borderRadius="4px" />

          <Skeleton width="60px" height="24px" borderRadius="4px" />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CartProductCardSkeleton;
